var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { MenuItem, Typography } from "@mui/material";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { EditableDataGrid } from "../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { MuiStack } from "../../../components";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { useAppSelector } from "../../../store/hooks";
import { systemColor } from "../../../theme/systemColor";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { SpareIssuesKeys } from "../../spareIssue/services/entity";
import { supplierListAPICall } from "../../spareParts/purchaseRequistion/services/apiCall";
import { PurchaseRequisitionKeys } from "../../spareParts/purchaseRequistion/services/entity";
import { statusListGet } from "../../stockAdjustment/apiCall";
import { getComplaintDealerCodeAPICall, proprietaryPartDetailsByProductIdAPICall, searchProductNameAndCodeAPICall } from "../services/apiCall";
import { ProprietaryWarrantyKeys } from "../services/entity";
import { dateFormate } from "../../../utils/utils";
var ProprietaryWarrantyDetails = function (props) {
    var _getLocalStorageItem, _crud$PurchaseRequisi, _crud$PurchaseRequisi2, _crud$ProprietaryWarr, _crud$ProprietaryWarr2, _crud$SpareIssuesKeys, _crud$SpareIssuesKeys2, _value$ProprietaryWar;
    var searchParams = useSearchParams()[0];
    var mode = searchParams.get('mode');
    var id = props.id, onChange = props.onChange, value = props.value, error = props.error;
    var crud = useAppSelector(function (state) { return state.crud; });
    var UserParentOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.ParentOrganizationId;
    var getSupplierByParentOrganization = function (param) { return supplierListAPICall(_objectSpread(_objectSpread({}, param), {}, {
        request: {
            ParentOrganizationId: UserParentOrganization
        }
    })); };
    var getPartListByPagination = function (params) { return searchProductNameAndCodeAPICall(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread({
            skip: 0,
            take: 10
        }, params.request)
    })); };
    var getStatusListBySystemName = function (params) { return statusListGet(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread(_objectSpread({}, params.request), {}, {
            SystemName: ProprietaryWarrantyKeys.SystemName
        })
    })); };
    useEffect(function () {
        getSupplierByParentOrganization({});
        getStatusListBySystemName({});
    }, []);
    var columns = [{
            type: 'searchSelect',
            field: 'Product',
            headerName: 'Part name & code',
            editable: true,
            flex: 1,
            headerAlign: 'left',
            minWidth: 200,
            getListData: getPartListByPagination,
            valueSetter: function (value, row) {
                return _objectSpread(_objectSpread({}, row), {}, {
                    ChildId: value === null || value === void 0 ? void 0 : value.id,
                    Product: value,
                    ChildName: value === null || value === void 0 ? void 0 : value.Name,
                    ChildCode: value === null || value === void 0 ? void 0 : value.SkuCode,
                    ProprietaryPartGroupId: value === null || value === void 0 ? void 0 : value.ProprietaryPartGroupId,
                    PartGroup: value === null || value === void 0 ? void 0 : value.PartGroup
                });
            },
            renderCell: function (params) {
                var _params$row, _params$row2, _params$row3, _params$row4;
                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "h5",
                    style: {
                        fontSize: '12px',
                        fontWeight: 400,
                        color: '#1B1D21'
                    }
                }, params !== null && params !== void 0 && (_params$row = params.row) !== null && _params$row !== void 0 && _params$row.ChildName ? "".concat(params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.ChildName) : ""), /*#__PURE__*/ React.createElement(Typography, {
                    style: {
                        fontSize: '12px',
                        fontWeight: 400,
                        color: '#6A7682'
                    }
                }, params !== null && params !== void 0 && (_params$row3 = params.row) !== null && _params$row3 !== void 0 && _params$row3.ChildCode ? "#".concat(params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.ChildCode) : ""));
            },
            apiKey: ProprietaryWarrantyKeys.SearchByProductNameAndCode,
            placeholder: 'Search Part by name',
            moreButtonText: 'Search More...',
            getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.Name) + " | " + (option === null || option === void 0 ? void 0 : option.SkuCode); },
            valueFormatter: function (value) { return value === null || value === void 0 ? void 0 : value.Name; },
            renderOption: function (props, option) {
                return /*#__PURE__*/ React.createElement(MenuItem, props, /*#__PURE__*/ React.createElement(MuiStack, {
                    width: '200px'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    sx: {
                        overflow: "hidden",
                        whiteSpace: 'wrap',
                        textOverflow: 'ellipsis'
                    }
                }, option === null || option === void 0 ? void 0 : option.Name)), /*#__PURE__*/ React.createElement(MuiStack, {
                    width: '100px',
                    borderLeft: "1px solid ".concat(systemColor.grey),
                    paddingX: 2
                }, /*#__PURE__*/ React.createElement(Typography, null, option === null || option === void 0 ? void 0 : option.SkuCode)));
            }
        }, {
            field: 'PartGroup',
            headerName: 'Part Group'
        }, {
            field: 'SerialNo',
            headerName: 'Part serial no',
            editable: true
        }, {
            type: 'singleSelect',
            field: 'SupplierId',
            headerName: 'Vendor',
            editable: true,
            valueOptions: (_crud$PurchaseRequisi = (_crud$PurchaseRequisi2 = crud[PurchaseRequisitionKeys.SupplierList]) === null || _crud$PurchaseRequisi2 === void 0 ? void 0 : _crud$PurchaseRequisi2.data) !== null && _crud$PurchaseRequisi !== void 0 ? _crud$PurchaseRequisi : [],
            getOptionLabel: function (option) {
                var _option$Name;
                return (_option$Name = option === null || option === void 0 ? void 0 : option.Name) !== null && _option$Name !== void 0 ? _option$Name : '';
            },
            getOptionValue: function (value) { return value === null || value === void 0 ? void 0 : value.id; },
            valueSetter: function (value, row) {
                return _objectSpread(_objectSpread({}, row), {}, {
                    SupplierId: value
                });
            }
        }, {
            field: 'LocalVenderName',
            headerName: 'Vendor dealer name',
            editable: true
        }, {
            type: 'singleSelect',
            field: 'DefectCodeId',
            headerName: 'Defect code',
            valueOptions: (_crud$ProprietaryWarr = (_crud$ProprietaryWarr2 = crud[ProprietaryWarrantyKeys.GetComplaintDelerCode]) === null || _crud$ProprietaryWarr2 === void 0 ? void 0 : _crud$ProprietaryWarr2.data) !== null && _crud$ProprietaryWarr !== void 0 ? _crud$ProprietaryWarr : [],
            getOptionLabel: function (option) {
                var _option$Name2;
                return (_option$Name2 = option === null || option === void 0 ? void 0 : option.Name) !== null && _option$Name2 !== void 0 ? _option$Name2 : '';
            },
            getOptionValue: function (value) { return value === null || value === void 0 ? void 0 : value.ComplaintId; },
            editable: true
        }, {
            type: 'singleSelect',
            field: 'StatusId',
            headerName: 'Status',
            editable: true,
            valueOptions: (_crud$SpareIssuesKeys = (_crud$SpareIssuesKeys2 = crud[SpareIssuesKeys.Status]) === null || _crud$SpareIssuesKeys2 === void 0 ? void 0 : _crud$SpareIssuesKeys2.data) !== null && _crud$SpareIssuesKeys !== void 0 ? _crud$SpareIssuesKeys : [],
            getOptionLabel: function (option) {
                var _option$Name3;
                return (_option$Name3 = option === null || option === void 0 ? void 0 : option.Name) !== null && _option$Name3 !== void 0 ? _option$Name3 : '';
            },
            getOptionValue: function (value) { return value === null || value === void 0 ? void 0 : value.id; },
            valueSetter: function (value, row) {
                var _crud$SpareIssuesKeys3;
                var StatusName = (_crud$SpareIssuesKeys3 = crud[SpareIssuesKeys.Status]) === null || _crud$SpareIssuesKeys3 === void 0 || (_crud$SpareIssuesKeys3 = _crud$SpareIssuesKeys3.data) === null || _crud$SpareIssuesKeys3 === void 0 ? void 0 : _crud$SpareIssuesKeys3.find(function (item) { return (item === null || item === void 0 ? void 0 : item.StatusId) === value; });
                console.log('Stastu', StatusName);
                return _objectSpread(_objectSpread({}, row), {}, {
                    StatusId: value,
                    StatusName: StatusName && (StatusName === null || StatusName === void 0 ? void 0 : StatusName.Name)
                });
            }
        }, {
            type: 'string',
            field: 'Remarks',
            headerName: 'Service advisor remarks',
            editable: true,
            placeholder: "Enter remarks"
        }, {
            type: 'date',
            field: 'SettlementDate',
            headerName: 'Claim Settlement Date',
            editable: true,
            valueFormatter: function (value, row) { return value ? dateFormate(value) : ''; }
        }];
    return /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        onChange: onChange,
        disableAddRow: false,
        dataGridHeader: "Proprietary warranty details",
        dataGridProps: {
            rowSelection: true,
            isCellEditable: function (params) {
                return true;
            },
            checkboxSelection: true,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            processRowUpdate: function (newRow, oldRow) { return __awaiter(void 0, void 0, void 0, function () {
                var _newRow$Product, _oldRow$Product, row, _newRow$Product2, _response$data, response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log('oldRow', newRow, oldRow);
                            row = newRow;
                            return [4 /*yield*/, getComplaintDealerCodeAPICall({
                                    request: {
                                        ChildId: newRow === null || newRow === void 0 ? void 0 : newRow.ChildId
                                    }
                                })];
                        case 1:
                            _a.sent();
                            if (!((newRow === null || newRow === void 0 || (_newRow$Product = newRow.Product) === null || _newRow$Product === void 0 ? void 0 : _newRow$Product.id) !== (oldRow === null || oldRow === void 0 || (_oldRow$Product = oldRow.Product) === null || _oldRow$Product === void 0 ? void 0 : _oldRow$Product.id))) return [3 /*break*/, 3];
                            return [4 /*yield*/, proprietaryPartDetailsByProductIdAPICall({
                                    request: {
                                        ChildId: newRow === null || newRow === void 0 || (_newRow$Product2 = newRow.Product) === null || _newRow$Product2 === void 0 ? void 0 : _newRow$Product2.id
                                    }
                                })];
                        case 2:
                            response = _a.sent();
                            row = _objectSpread(_objectSpread({}, newRow), {}, {
                                StatusId: response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.StatusId
                            });
                            _a.label = 3;
                        case 3: return [2 /*return*/, row];
                    }
                });
            }); }
        },
        rows: (_value$ProprietaryWar = value === null || value === void 0 ? void 0 : value.ProprietaryWarrantyPartDetails) !== null && _value$ProprietaryWar !== void 0 ? _value$ProprietaryWar : [{
                id: 1
            }],
        validationModel: {
            Product: function (productValue, row, rowsLookup) {
                var _rowsLookup$values;
                if (rowsLookup !== null && rowsLookup !== void 0 && (_rowsLookup$values = rowsLookup.values()) !== null && _rowsLookup$values !== void 0 && (_rowsLookup$values = _rowsLookup$values.toArray()) !== null && _rowsLookup$values !== void 0 && _rowsLookup$values.some(function (it) { return it.ChildId === (productValue === null || productValue === void 0 ? void 0 : productValue.id); }))
                    return "Part already requested.";
                else
                    return undefined;
            }
        },
        error: error === null || error === void 0 ? void 0 : error['ProprietaryWarrantyPartDetails']
    });
};
export default ProprietaryWarrantyDetails;
